
































import { defineComponent, inject, ref, watch } from '@nuxtjs/composition-api';
import { uniq } from 'lodash-es';
import { debounce } from 'throttle-debounce';
import 'vue-slider-component/theme/default.css';
import { CONFIG_STORE_CURRENCY } from '~/utils/provides';

export default defineComponent({
  name: 'FacetDropdownPrice',
  components: {
    // Lazy load it because it requires access to `document` which
    // breaks SSR, so we want to avoid rendering it until the client-side has loaded
    // Async components does that for us!
    VueSlider: () => import('vue-slider-component'),
  },
  props: {
    value: {
      type: null,
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
    lazy: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    // to protect the slider just remove the duplicated props values
    const uniqueValue = uniq(props.value);

    const range = ref<[number, number]>(uniqueValue?.length ? ([...uniqueValue] as [number, number]) : [0, 0]);

    const currencyCode = inject(CONFIG_STORE_CURRENCY);

    function updatePriceRange(valueIdx: 0 | 1, e: InputEvent) {
      const inputValue = Number((e.target as any).value);
      if (Number.isNaN(inputValue)) {
        return;
      }

      const newValue: [number, number] = [...range.value];
      newValue[valueIdx] =
        valueIdx === 0
          ? Math.max((props.options as [number, number])[valueIdx], inputValue)
          : Math.min((props.options as [number, number])[valueIdx], inputValue);
      range.value = newValue;
    }

    if (!props.lazy) {
      watch(range, debounce(300, apply));
    }

    function apply() {
      emit('input', range.value);
      emit('close');
    }

    function cancel() {
      range.value = [...props.value] as typeof range.value;
      emit('close');
    }

    return {
      range,
      updatePriceRange,
      apply,
      cancel,
      currencyCode,
    };
  },
});
